export default __webpack_public_path__ + "static/media/emptyCanvasCover.70b243f4.png";